import React from 'react';
import { motion } from 'framer-motion';
import { Trash2 } from 'lucide-react';
import { useShoppingList } from '../../hooks/shopping/useShoppingList';

interface DeleteListButtonProps {
  listId: string;
  onDeleted?: () => void;
}

export const DeleteListButton: React.FC<DeleteListButtonProps> = ({
  listId,
  onDeleted
}) => {
  const { isDeleting, error, handleDelete } = useShoppingList();

  const handleClick = async () => {
    if (window.confirm('¿Estás seguro de que quieres eliminar esta lista?')) {
      await handleDelete(listId);
      onDeleted?.();
    }
  };

  return (
    <>
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={handleClick}
        disabled={isDeleting}
        className="p-2 text-gray-500 hover:text-red-500 transition-colors disabled:opacity-50"
        title="Eliminar lista"
      >
        <Trash2 size={18} />
      </motion.button>
      
      {error && (
        <p className="text-sm text-red-500 mt-2">{error}</p>
      )}
    </>
  );
};